import { endpoint, EndpointError } from 'endpoints/endpoint';

// FIX LIVEKIT: set right type
export type WebhookParams = any;
export type WebhookResult = { data: string };
export type WebhookError = EndpointError;

export const webhook = endpoint<WebhookParams, WebhookResult, WebhookError>({
  method: 'POST',
  url: () => '/live-kit/webhook',
});
